import React, { useEffect, useState } from "react";
import { Col, Row, Button, Input, InputGroup } from "reactstrap";
import _ from "lodash";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ItemTypeahead, ServiceThreadSpinner } from "..";
import { api, constants } from "../../utils";
import { DesktopContainer } from "../../layouts";
import { toast } from "react-toastify";
import Select from "react-select";
import ColValue from "./ColValue";
import ErrorDiv from "./ErrorDiv";
import classNames from "classnames";

//const initialHours = {
//  lbl8: "",
//  lbl40: "",
//  lbl80: "",
//  lbl120: "",
//  pphTxt: "",
//  Runtime: "",
//  efficiency: "",
//};

const emptyScreen = {
   txtTime: "",
   specification: null,
   pphInfo: null,
   lblPPH: "",
   lblRunTime: "",
   txtEfficiency: "",
   txtSpindleUsg: "",
   txtQty: "",
   machineSetupList: [],
   selectedMachine: { label: "---Select---", value: -1 },
};

export default function PPHCalculator(props) {
   const navigate = useNavigate();
   const location = useLocation();
   const { itemNumber } = useParams();
   const [buildQtyValid, setBuildQtyValid] = useState(true);
   const [effValid, setEffValid] = useState(true);
   const [fields, setFields] = useState(emptyScreen);
   const [isLoading, setIsLoading] = useState(false);
   const [item, setItem] = useState(null);
   const [valid, setValid] = useState(true);

   let screenForm = {
      txtTime: "",
      specification: null,
      pphInfo: null,
      lblPPH: "",
      lblRunTime: "",
      txtEfficiency: "",
      txtSpindleUsg: "",
      txtQty: "",
      machineSetupList: [],
      selectedMachine: { label: "---Select---", value: -1 },
      lbl8Hr: "",
      lbl40Hr: "",
      lbl80Hr: "",
      lbl120Hr: "",
      lblNeededSpindles: "",
      lblAvailSpindles: "",
      redText: false,
   };

   useEffect(() => {
      if (itemNumber) {
         const json = decodeURI(itemNumber);
         const opt = JSON.parse(json);
         setItem(opt);
      } else {
         if (location.state !== item) {
            setItem(location.state);
         }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location]);

   useEffect(() => {
      if (fields.calculate && fields.txtQty) {
         Calculate();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [fields]);

   async function Calculate() {
      if (item === null) {
         toast.error("please select an item before clicking load");
         return;
      }
      if (!fields.txtEfficiency) {
         toast.error("Efficiency is a required field");
         return;
      }
      if (!fields.txtQty) {
         toast.error("Build Qty is a required field");
         return;
      }
      if (fields.selectedMachine.value === -1) {
         toast.error("Machine Type is a required field");
         return;
      }
      let finalQty = 0;
      finalQty = fields.txtQty;
      if (typeof finalQty === "string") {
         if (_.includes(fields.txtQty, ",")) {
            finalQty = fields.txtQty.replace(/,/g, "");
         }
         finalQty = parseFloat(finalQty);
         if (isNaN(finalQty)) {
            toast.error("Build Qty is a required field");
            return;
         }
      }
      let itmNumber = item.value;
      let payload = {
         itemNumber: itmNumber,
         percentage: fields.txtEfficiency,
         buildQty: finalQty,
         txtTime: fields.txtTime,
         machineId: fields.selectedMachine.value,
      };
      await api
         .post(`Production/Calculate`, payload)
         .then((r) => {
            if (r.data.success) {
               let vm = r.data.calc;
               let newScreenForm = _.cloneDeep(fields);
               newScreenForm.lbl8Hr = vm.lbl8Hr;
               newScreenForm.lbl40Hr = vm.lbl40Hr;
               newScreenForm.lbl80Hr = vm.lbl80Hr;
               newScreenForm.lbl120Hr = vm.lbl120Hr;
               newScreenForm.lblNeededSpindles = vm.lblNeededSpindles;
               newScreenForm.lblAvailSpindles = vm.lblAvailSpindles;
               newScreenForm.lblPPH = vm.lblPPH;
               newScreenForm.redText = vm.redText;
               newScreenForm.calculate = false;
               setFields(newScreenForm);
            }
         })
         .catch(api.catchHandler);
   }

   function ColPrompt({ title }) {
      return (
         <Col xxl={6} className="text-white">
            <h5 className="text-end">{title}:</h5>
         </Col>
      );
   }

   function getDays() {
      // How many days from today will be Friday of the current week?
      let days = 0;
      switch (new Date().getDay()) {
         case 6:
            days = 6;
            break;
         case 0:
            days = 5;
            break;
         case 1:
            days = 4;
            break;
         case 2:
            days = 3;
            break;
         case 3:
            days = 2;
            break;
         case 4:
            days = 1;
            break;
         case 5:
            days = 0;
            break;
         default:
            break;

      }
      return days;
   }

   async function GetItemPlanning(startDate, endDate, itemNum) {
      let payload = {
         StartDate: startDate,
         EndDate: endDate,
         ItemNumber: itemNum,
      };
      await api
         .post(`Production/GetItemPlanning`, payload)
         .then((r) => {
            if (r.data.success) {
               let tmp = r.data.itemPlann;
               if (!_.isNil(tmp) && tmp.length) {
                  screenForm.txtQty = tmp[0].quantityToBuildPounds.toLocaleString("en-US", { maximumFractionDigits: 0 });
                  if (screenForm.txtQty) {
                     screenForm.calculate = true;
                  }
               }
            } else {
               setIsLoading(false);
               toast.error(r.data.message);
               throw new Error("failed to get item planning");
            }
         })
         .catch(api.catchHandler);
   }

   async function GetPPH(machineSetupId = 0) {
      if (item === null) {
         toast.error("please select an item before clicking load");
         return;
      }
      let itmNumber = item.value;
      let payload = {
         itemNumber: itmNumber,
         MachineSetupId: machineSetupId,
      };
      await api.post(`Production/GetPPH`, payload).then((r) => {
         if (r.data.success) {
            if (screenForm.machineSetupList.length === 1) {
               screenForm.pphInfo = r.data.pphTemp;
               let pph = screenForm.pphInfo.pph * (screenForm.pphInfo.rate / 100);
               if (pph > 0) {
                  screenForm.lblPPH = pph.toFixed(2);
               } else {
                  toast.error("PPH is 0 or less");
               }
               if (!_.isEmpty(screenForm.pphInfo.runTime))
                  screenForm.lblRunTime = screenForm.pphInfo.runTime;
               screenForm.txtEfficiency = screenForm.pphInfo.rate;
               screenForm.txtSpindleUsg = screenForm.pphInfo.spindles;
            } else {
               if (machineSetupId) {
                  screenForm.pphInfo = r.data.pphTemp;
                  let pph = screenForm.pphInfo.pph * (screenForm.pphInfo.rate / 100);
                  if (pph > 0) {
                     screenForm.lblPPH = pph.toFixed(2);
                  } else {
                     toast.error("PPH is 0 or less");
                  }
                  if (!_.isEmpty(screenForm.pphInfo.runTime))
                     screenForm.lblRunTime = screenForm.pphInfo.runTime;
                  screenForm.txtEfficiency = screenForm.pphInfo.rate;
                  screenForm.txtSpindleUsg = screenForm.pphInfo.spindles;
               }
            }
         } else {
            setIsLoading(false);
         }
      });
   }

   const handleInputChange = (event) => {
      const { value } = event.target;
      const regex = /^[+-]?|[+-]?([0-9]+(\.[0-9]*)?|\.[0-9]+)$/;
      const found = value.match(regex);
      if (found === null) {
         toast.warning(`your number ${value} is not formatted correctly please try again`);
         return;
      }

      const parsedValue = parseFloat(value);
      if (parsedValue >= 0 && parsedValue <= 9999999) {
         onChange("txtQty", value);
         setBuildQtyValid(true);
      } else {
         onChange("txtQty", value);
         setBuildQtyValid(false);
      }
   };

   const handleInputEffChange = (event) => {
      const { value } = event.target;
      const regex = /^[1-9][0-9]?$|^100$/;
      if (regex.test(value)) {
         onChange("txtEfficiency", value);
         setEffValid(true);
      } else {
         onChange("txtEfficiency", value);
         setEffValid(false);
      }
   };

   const handleInputTimeChange = (event) => {
      const { value } = event.target;
      const regex = /^([01]\d|[0-9][0-9]):([0-5]\d)$/;
      if (regex.test(value)) {
         onChange("txtTime", value);
         setValid(true);
      } else {
         onChange("txtTime", value);
         setValid(false);
      }
   };

   async function LoadBuildQty() {
      if (item === null) {
         toast.error("please select an item before clicking load");
         setIsLoading(false);
         return;
      }
      let itmNumber = item.value;
      const days = getDays();
      const startDate = new Date(Date.now()).setFullYear(new Date(Date.now()).getFullYear() - 200); // Production planning gets any incomplete order from previous dates
      const endDate = new Date(Date.now()).setDate(new Date(Date.now()).getDate() + days);
      const formattedStartDate = new Date(startDate).toISOString();
      const formattedEndDate = new Date(endDate).toISOString();
      await GetItemPlanning(formattedStartDate, formattedEndDate, itmNumber);
   }

   async function LoadClick() {
      setIsLoading(true);
      if (item === null) {
         setIsLoading(false);
         toast.error("please select an item before clicking load");
         return;
      }
      ResetTime(); // setting State Specifically Time
      await SetSpec(); // await the first call to set the itemspecification //need to verify we handle the erros accordingly
      await LoadMachineSetups(); // set the machine state at the end
      // this method works very closely like the original need to transform it still to allow the machine type to be selected rather than just being the first in the list
      setFields(screenForm);
      setIsLoading(false);
   }

   async function LoadMachineSetups(machineSetupId = 0) {
      let machineSetupList = [];
      let tmp = [];
      tmp = _.chain(screenForm?.specification?.machineSetupList)
         .filter((x) => x.machineType !== 4 && x.isActive)
         .orderBy((x) => x.orderToProcess)
         .orderBy((x) => x.machineDescription)
         .value();
      if (tmp.length < 1) {
         setIsLoading(false);
         toast.error("No active machine setups exist for this item except the 'Other' setup");
         return;
      } else {
         machineSetupList = _.map(tmp, (x) => {
            x.label = x.machineDescription;
            x.value = x.machineType;
            return x;
         });
         screenForm.machineSetupList = machineSetupList;
         // will be set the the setup list
         if (machineSetupList.length === 1) {
            //sole set up
            screenForm.selectedMachine = machineSetupList[0];
         }
         await GetPPH(machineSetupId);
         await LoadBuildQty();
      }
   }

   const onChange = (property, value) => {
      let copy = _.cloneDeep(fields);
      _.set(copy, property, value);
      setFields(copy);
   };

   const onChangeMachine = async (opt) => {
      setIsLoading(true);
      if (opt === null) return;
      ResetTime(); // setting State Specifically Time
      await SetSpec();
      await LoadMachineSetups(opt.value);
      screenForm.selectedMachine = opt;
      setFields(screenForm);
      setIsLoading(false);
   };

   function ResetTime() {
      const days = getDays();
      let value = "";
      if (days > 0) {
         // Reset the time available for a new item being loaded or if page first loaded with no item passed in
         let dt = new Date();
         dt.setDate(dt.getDate() + days);
         dt.setHours(8, 0, 0, 0); // 8 AM on Friday of the current week
         let span = dt - new Date();
         let hours = Math.floor(span / (60 * 60 * 1000));
         let mins = Math.floor((span / (60 * 1000)) % 60);
         value = hours.toString() + ":" + mins.toString().padStart(2, "0");
         screenForm.txtTime = value;
      } else {
         value = "40:00"; // Default to 40 hours if it is Friday
         screenForm.txtTime = value;
      }
   }

   async function SetSpec() {
      if (item === null) {
         toast.error("please select an item before clicking load");
         setIsLoading(false);
         return;
      }
      let itmNumber = item.value;
      await api
         .fetch(`Production/GetSpecByItem/${itmNumber}`)
         .then((r) => {
            if (r.data.success) {
               screenForm.specification = r.data.specification;
            } else {
               setIsLoading(false);
               toast.error(r.data.message);
               throw new Error(`failed to find the spec for ${itmNumber}`);
            }
         })
         .catch(api.catchHandler);
   }

   return (
      (document.title = `PPH Calculator`),
      (
         <DesktopContainer screenName={"Machine Production Calculator"}>
            <div className="filter-header mb-3">
               <Row className="mb-5 mt-3">
                  <Col xxl={3} className="text-white">
                     <h5 className="text-end">{"Item"}:</h5>
                  </Col>
                  <ColValue>
                     <ItemTypeahead
                        value={item}
                        onChange={(opt) =>
                           navigate(constants.ENDPOINTS.pphCalculator, {
                              state: opt,
                              replace: false,
                           })
                        }
                     />
                  </ColValue>
                  <Col>
                     <Button
                        className={"shredButton"}
                        onClick={() => LoadClick()}
                        children={"Load"}
                     />
                  </Col>
               </Row>
               <ServiceThreadSpinner on={isLoading} white>
                  {item && (
                     <Row>
                        <Col xxl={{ offset: 3, size: 3 }}>
                           <a rel="noreferrer"
                              href={`/machine-setups/${JSON.stringify({
                                 value: item.value,
                                 label: item.label,
                              })}`}
                              target="_blank"
                              style={{
                                 fontWeight: "bold",
                                 padding: "3px",
                                 backgroundColor: "#FFF",
                                 borderRadius: "3px",
                              }}
                              className="styledAnchor mb-1"
                           >
                              View Machine Setups
                           </a>
                        </Col>
                     </Row>
                  )}
                  <Row>
                     <Col>
                        <Row className="mb-2">
                           <ColPrompt title={"Machine Type"} />
                           <ColValue>
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={fields.machineSetupList}
                                 value={fields.selectedMachine}
                                 onChange={(opt) => onChangeMachine(opt)}
                                 isDisabled={
                                    _.isEmpty(fields.machineSetupList) ||
                                    fields.machineSetupList.length === 1
                                 }
                              />
                           </ColValue>
                        </Row>
                        <Row className="mb-2">
                           <ColPrompt title={"MSR Spindles Std"} />
                           <ColValue size={4}>
                              <Input value={fields.txtSpindleUsg} disabled readOnly />
                           </ColValue>
                        </Row>
                        <Row className="mb-2">
                           <ColPrompt title={"Build Qty"} />
                           <ColValue size={4}>
                              <Input
                                 type="text"
                                 value={fields.txtQty}
                                 onChange={handleInputChange}
                              />
                              {!buildQtyValid && <ErrorDiv>0-9,999,999</ErrorDiv>}
                           </ColValue>
                        </Row>
                        <Row className="mb-2">
                           <ColPrompt title={"Shifts/Time (HHH:MM)"} />
                           <ColValue size={4}>
                              <InputGroup>
                                 <Input
                                    type="text"
                                    value={fields.txtTime}
                                    onChange={handleInputTimeChange}
                                    className={valid ? "" : "is-invalid"}
                                    style={{ borderRadius: "6px" }}
                                 />
                                 {!valid && (
                                    <ErrorDiv>
                                       Please correct the time format (HHH:MM)
                                    </ErrorDiv>
                                 )}
                              </InputGroup>
                           </ColValue>
                        </Row>
                        <Row className="mb-2">
                           <ColPrompt title={"Efficiency (%)"} />
                           <ColValue size={4}>
                              <Input
                                 type="text"
                                 value={fields.txtEfficiency}
                                 onChange={handleInputEffChange}
                                 className={effValid ? "" : "is-invalid"}
                                 style={{ borderRadius: "6px" }}
                              />
                              {!effValid && <ErrorDiv>1-100 only</ErrorDiv>}
                           </ColValue>
                        </Row>
                        <Row className="mb-2 text-white">
                           <ColPrompt title={"PPH at Designated Efficiency"} />
                           <ColValue>
                              <span style={{ fontSize: "1.25rem" }}>{fields.lblPPH}</span>
                           </ColValue>
                        </Row>
                        <Row className="mb-2 text-white">
                           <ColPrompt title={"Run Time (HH:MM:SS)"} />
                           <ColValue>
                              <span style={{ fontSize: "1.25rem" }}>
                                 {fields.lblRunTime}
                              </span>
                           </ColValue>
                        </Row>
                        <Row>
                           <Col>
                              <Button
                                 disabled={
                                    _.isNil(fields.selectedMachine) ||
                                    fields.selectedMachine.value === -1
                                 }
                                 className="shredButton float-end"
                                 onClick={() => Calculate()}
                              >
                                 Calculate
                              </Button>
                           </Col>
                        </Row>
                     </Col>

                     <Col className="text-white">
                        <div className="fw-bold text-decoration-underline fs-5">
                           MSR Standards PPH for:
                        </div>
                        <div className="d-flex flex-column fs-5">
                           <div className="d-flex justify-content-start">
                              <span>8 Hours</span>
                              <span style={{ marginLeft: "15px" }}>{fields.lbl8Hr}</span>
                           </div>
                           <div className="d-flex justify-content-start">
                              <span>40 Hours</span>
                              <span style={{ marginLeft: "15px" }}>{fields.lbl40Hr}</span>
                           </div>
                           <div className="d-flex justify-content-start">
                              <span>80 Hours</span>
                              <span style={{ marginLeft: "15px" }}>{fields.lbl80Hr}</span>
                           </div>
                           <div className="d-flex justify-content-start">
                              <span>120 Hours</span>
                              <span style={{ marginLeft: "15px" }}>
                                 {fields.lbl120Hr}
                              </span>
                           </div>
                        </div>

                        <div className="mt-5 fw-bold text-decoration-underline fs-5">
                           Calculated Values:
                        </div>
                        <div className="d-flex flex-column fs-5">
                           <div className="d-flex justify-content-start">
                              <span>Spindles Needed</span>
                              <span
                                 style={{ marginLeft: "15px" }}
                                 className={classNames(
                                    {
                                       "text-brightRed": fields.redText,
                                       "bg-white": fields.redText,
                                    },
                                    "px-2"
                                 )}
                              >
                                 {fields.lblNeededSpindles}
                              </span>
                           </div>
                           <div className="d-flex justify-content-start">
                              <span>Spindles Available</span>
                              <span style={{ marginLeft: "15px" }}>
                                 {fields.lblAvailSpindles}
                              </span>
                           </div>
                        </div>
                     </Col>
                  </Row>
               </ServiceThreadSpinner>
            </div>
         </DesktopContainer>
      )
   );
}
